import { gql } from '@apollo/client';
import type { TypedDocumentNode } from '@apollo/client';

import type { ColorAndVariantValuesDictionary } from './colorConfiguration.types';

type SaveColorConfigurationMutation = {
  updateExtranetColorConfiguration: ColorAndVariantValuesDictionary;
};

export const SAVE_COLOR_CONFIGURATION: TypedDocumentNode<
  SaveColorConfigurationMutation,
  { configuration: ColorAndVariantValuesDictionary }
> = gql`
  mutation SaveColorConfiguration($configuration: ExtranetColorConfigurationInput) {
    updateExtranetColorConfiguration(configuration: $configuration) {
      id
      primary {
        value
        contrast {
          value
        }
        dark {
          value
        }
        darker {
          value
        }
      }
      secondary {
        value
        contrast {
          value
        }
        dark {
          value
        }
        darker {
          value
        }
      }
      alt_1 {
        value
        contrast {
          value
        }
        dark {
          value
        }
        darker {
          value
        }
      }
      alt_2 {
        value
        contrast {
          value
        }
        dark {
          value
        }
        darker {
          value
        }
      }
      alt_3 {
        value
        contrast {
          value
        }
        dark {
          value
        }
        darker {
          value
        }
      }
    }
  }
`;
